import {
  FiCode,
  FiPenTool,
  FiBox,
  FiTrendingUp,
  FiLifeBuoy,
  FiUsers,
  FiDollarSign,
  FiSettings,
  FiBriefcase,
} from 'react-icons/fi';
import { getHashedColor } from '@/utils/colorHash';

// Matched by substring against a department name — covers the most common
// department types with a recognizable, on-brand icon+color instead of
// falling back to a hashed color for everything.
const DEPARTMENT_ICON_MATCHERS = [
  { test: /engineer|develop|tech/i, Icon: FiCode, color: 'blue' },
  { test: /design/i, Icon: FiPenTool, color: 'purple' },
  { test: /product/i, Icon: FiBox, color: 'indigo' },
  { test: /marketing|growth/i, Icon: FiTrendingUp, color: 'orange' },
  { test: /support|success/i, Icon: FiLifeBuoy, color: 'success' },
  { test: /hr|human resource|people/i, Icon: FiUsers, color: 'rose' },
  { test: /finance|account/i, Icon: FiDollarSign, color: 'warning' },
  { test: /operations|ops/i, Icon: FiSettings, color: 'violet' },
];

// Wider palette than the matchers above use, so unrecognized department
// names still get varied (if arbitrary) colors instead of clustering on
// whichever hue happens to hash most often.
const FALLBACK_PALETTE = [
  'blue',
  'indigo',
  'purple',
  'orchid',
  'violet',
  'pink',
  'rose',
  'orange',
];

export const resolveDepartmentIcon = (name) => {
  const match = DEPARTMENT_ICON_MATCHERS.find(({ test }) =>
    test.test(name || '')
  );
  const color = match?.color || getHashedColor(name, FALLBACK_PALETTE);

  return {
    Icon: match?.Icon || FiBriefcase,
    iconColor: `var(--${color}-700)`,
    iconBg: `var(--${color}-100)`,
  };
};
